<div class="card-wrapper">
  <div class="event-type" [ngStyle]="{ color: getEventTypeColor(eventType) }">
    {{ getEventTypeLabel(eventType) }}
  </div>
  <div
    class="stock-info"
    [class.cursor-pointer]="eventType !== EventType.Ipo"
    (click)="navigateToStock(eventType)"
  >
    @if (eventData().image) {
      <p-avatar shape="circle">
        <img [src]="eventData().image" [alt]="eventData().name" />
      </p-avatar>
    }
    <div class="wrapper">
      <div class="company-name text-truncate" [title]="eventData().name">
        {{ eventData().name }}
      </div>
      @if (eventData().symbol) {
        <div class="company-symbol text-truncate">{{ eventData().symbol }}</div>
      }
    </div>
  </div>
  <div class="event-details">
    @switch (eventType) {
      @case (EventType.Dividend) {
        <div class="date-block">
          <label class="label">{{ 'events.totalDividends' | translate }}</label>
          <span class="value">{{ eventData().eventData.totalDividends || '—' }}</span>
        </div>
        <div class="date-block">
          <label class="label">{{ 'events.dueDate' | translate }}</label>
          <span class="value">{{ eventData().eventData.dueDate || '—' }}</span>
        </div>
      }
      @case (EventType.Earning) {
        <div class="date-block">
          <label class="label">{{ 'events.date' | translate }}</label>
          <span class="value">{{ eventData().eventData.earningDate || '—' }}</span>
        </div>
        <div class="date-block">
          <label class="label">{{ 'events.fiscalPeriod' | translate }}</label>
          <span class="value">{{ eventData().eventData.fiscalPeriod || '—' }}</span>
        </div>
      }
      @case (EventType.Ipo) {
        <div class="date-block">
          <label class="label">{{ 'events.price_range' | translate }}</label>
          <span class="value"
            >{{ eventData().eventData.fromPrice || '—' }} -
            {{ eventData().eventData.toPrice || '—' }}
          </span>
        </div>
        <div class="date-block">
          <label class="label">{{ 'events.ipoDateForIndividuals' | translate }}</label>
          <span class="value">{{ eventData().eventData.ipoDateForIndividuals || '—' }}</span>
        </div>
      }
    }
  </div>
</div>
